import type { ConsentsFeatureConfig } from './type';

export const consents: ConsentsFeatureConfig = {
    showPrintInDetail: false,
};
